import React from 'react';
import _get from 'lodash/get';
import { translate } from 'react-i18next';
import { Tag, TextButton } from 'wix-style-react';
import {
  FILTER_TAG_PATTERNS,
  MIN_BUDGET,
  MAX_BUDGET,
} from '../../../utils/constants';
import s from './tags.scss';

const Tags = ({ t, filters, onClear, onTagRemove, possibleLanguages }) => {
  const tags = filters.serviceIds
    .map(service => ({
      id: `${FILTER_TAG_PATTERNS.SERVICE}${service}`,
      label: t(`client-exploreexperts-${service}-cta`),
    }))
    .concat(
      filters.categoryIds.map(category => ({
        id: `${FILTER_TAG_PATTERNS.CATEGORY}${category}`,
        label: t(`client-exploreexperts-${category}-cta`),
      })),
    )
    .concat(
      filters.lang.map(l => {
        const lang = possibleLanguages.find(item => item.key === l);
        return lang
          ? {
              id: `${FILTER_TAG_PATTERNS.LANGUAGE}${lang.key}`,
              label: lang.displayName,
            }
          : undefined;
      }),
    )
    .concat(
      filters.lower &&
        filters.upper &&
        !(filters.lower === MIN_BUDGET && filters.upper >= MAX_BUDGET)
        ? {
            id: FILTER_TAG_PATTERNS.BUDGET,
            label: `$${filters.lower.toLocaleString()}${
              filters.upper < MAX_BUDGET
                ? ` - $${filters.upper.toLocaleString()}`
                : t('client-exploreexperts-filter-price-max-plus-sign')
            }`,
          }
        : undefined,
    )
    .concat(
      _get(filters, 'location.country')
        ? {
            id: FILTER_TAG_PATTERNS.LOCATION,
            label: filters.location.city
              ? `${filters.location.city}, ${filters.location.country}`
              : filters.location.country,
          }
        : undefined,
    );

  return (
    <div className={s.root} data-hook="tags-section">
      {tags
        .filter(_ => _)
        .map(tag => (
          <Tag
            id={tag.id}
            key={tag.id}
            className={s.filterTag}
            onRemove={id => onTagRemove(id)}
            size="large"
            dataHook={`filter-tag-${tag.id}`}
          >
            {tag.label}
          </Tag>
        ))}
      <TextButton
        underline="onHover"
        skin="dark"
        onClick={onClear}
        dataHook="clear-all-filters-button"
        className={s.clearAllButton}
      >
        {t('client-exploreexperts-card-clearall')}
      </TextButton>
    </div>
  );
};
export default translate()(Tags);
